import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('product-drop-ship')
class ProductDropShip extends LitElement {
  @property({ type: Number, attribute: 'variant-id' })
  accessor variantId;

  constructor() {
    super();
    this.dropShipMessage = null;
  }

  createRenderRoot() {
    return this;
  }

  _handleVariantChange = (event) => {
    const { value } = event.detail;
    this.variantId = value;
    this._setDropShipMessage();
  };

  _setDropShipMessage() {
    const { dateOptions = [], message = null } = window.theme.dropShip;
    if (
      !dateOptions.length ||
      !message ||
      !message.split(' ').includes('{days}')
    )
      return;

    if (!this.variantId) return;

    const currentDate =
      dateOptions.filter(
        (option) => String(option.id) === String(this.variantId),
      )[0]?.date || null;

    if (currentDate) {
      const preparedMessage = message.replace('{days}', currentDate);
      this.dropShipMessage = preparedMessage;
    } else this.dropShipMessage = null;
  }

  connectedCallback() {
    super.connectedCallback();
    this._setDropShipMessage();
    document.addEventListener('pdp:variant-change', this._handleVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener(
      'pdp:variant-change',
      this._handleVariantChange,
    );
    super.disconnectedCallback();
  }

  render() {
    if (!this.dropShipMessage) return html``;

    return html`
      <div>
        <p class="body-3 py-[16px]">${this.dropShipMessage}</p>
      </div
    `;
  }
}

export default ProductDropShip;
